import type { GoalBoardCard } from '../services/goalService'
import { GOAL_PRIORITY_OPTIONS } from './goalOptions'
import { nextWhenWords as sharedNextWhenWords } from './skillWords'

/**
 * Words for a goal's progress, priority and next thing (Goals UX pass
 * 2026-09-06). One place, so the list row, the summary line and the rail say
 * the same thing. Every clock time names its zone.
 */

/** "45% along" · null when nothing yet. */
export function progressWords(progress: number | null | undefined): string | null {
  const p = Math.round(Number(progress || 0))
  return p > 0 ? `${p}% along` : null
}

export function priorityWord(priority: string | null | undefined): string {
  return GOAL_PRIORITY_OPTIONS.find((o) => o.value === priority)?.label || 'Normal'
}

/** "today at 6:30 PM PDT" · "Tue, Sep 8" · "past its time · Thu, Sep 10" · null — the
 *  skill surfaces' function, so a goal's next reads exactly as a skill's. */
export function nextWhenWords(next: GoalBoardCard['next'] | null | undefined, tz?: string | null): string | null {
  return sharedNextWhenWords(next, tz)
}

/** "Next: <title>" with the kind when it is not a task, and where a skill's next really lives. */
export function nextTitleWords(next: GoalBoardCard['next'] | null | undefined): string | null {
  if (!next) return null
  if (next.kind === 'skill' && next.via?.title) return `${next.via.title} (${next.title})`
  return next.title || null
}
